// Content loader utility for loading JSON content files
// Based on the True Light pattern

async function fetchJSON(url) {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return await response.json()
  } catch (error) {
    console.warn(`Failed to load ${url}:`, error)
    return null
  }
}

function deepMerge(target, source) {
  const output = { ...target }

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] })
        } else {
          output[key] = deepMerge(target[key], source[key])
        }
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }

  return output
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

export async function loadContent() {
  // Start with empty base
  let content = {}

  // Load static content (rarely changes)
  const staticContent = await fetchJSON('/static.json')
  if (staticContent) {
    content = deepMerge(content, staticContent)
  }

  // Load dynamic content (frequently changes) - higher priority
  const dynamicContent = await fetchJSON('/dynamic.json')
  if (dynamicContent) {
    content = deepMerge(content, dynamicContent)
  }

  return content
}

export async function loadEvents() {
  const events = await fetchJSON('/events.json')
  return events || { events: { en: [], zh: [] } }
}

export async function loadAllContent() {
  const [content, eventsData] = await Promise.all([
    loadContent(),
    loadEvents()
  ])

  return {
    ...content,
    ...eventsData
  }
}
